export default __webpack_public_path__ + "static/media/zoom-in-icon.a96f83cf.svg";